import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import order from './modules/order'
import dict from './modules/dict'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { user, order, dict },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo
  }
})

